module.exports = __webpack_public_path__ + "img/icon15.58f4feba.svg";